import { RouteConfig } from 'vue-router'

const AIAPI = () => import('../views/demo/AIAPI.vue')
const SMSOTP = () => import('../views/demo/SMSOTP.vue')
const FormAutocomplete = () => import('../views/demo/FormAutocomplete.vue')
const MerchantTransfer = () => import('../views/demo/MerchantTransfer.vue')

export const aiAPIRoute: RouteConfig = {
  path: '/demo/ai-api',
  name: 'demoj_ai_api',
  component: AIAPI,
  meta: {
    title: 'AI API demo',
  },
}

export const smsOTPRoute: RouteConfig = {
  path: '/demo/sms-otp',
  name: 'demo_sms_otp',
  component: SMSOTP,
  meta: {
    title: 'SMS OTP demo',
  },
}

export const formAutoCompleteRoute: RouteConfig = {
  path: '/demo/form-auto-complete',
  name: 'demo_form_auto_complete',
  component: FormAutocomplete,
  meta: {
    title: 'Form autocomplete demo',
  },
}

export const merchantTransferRoute: RouteConfig = {
  path: '/demo/merchant-transfer',
  name: 'demo_merchant_transfer',
  component: MerchantTransfer,
  meta: {
    title: '商家转账 demo',
  },
}

export default [aiAPIRoute, smsOTPRoute, formAutoCompleteRoute, merchantTransferRoute]
